import {
  Button,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  Radio,
  RadioGroup,
  SelectionControlLabel,
  Typography,
} from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { useCommonContext } from '../../../../hooks/useContexts';
import { IReceiptSelector } from '../../../../models/purchase-history/add-receipt';

export const SelectReceiptType = ({
  closeDrawer,
  drawerStepper,
  setDrawerStepper,
}: IReceiptSelector) => {
  const [formType, setFormType] = useState('InStore');

  const { isMobile } = useCommonContext();

  const handleFormChange = (event: { target: HTMLInputElement }) => {
    setFormType((event.target as HTMLInputElement).value);
  };

  const handleContinueButton = (type?: string) => {
    if (type === 'Select') {
      setDrawerStepper(1);
      return;
    }
    if (type === 'Scan') {
      setDrawerStepper(4);
      return;
    }
    if (formType === 'InStore') {
      setDrawerStepper(2);
      return;
    }
    if (formType === 'Online') {
      setDrawerStepper(3);
    }
  };

  return (
    <div
      data-testid="selectReceiptType"
      className="sui-flex sui-flex-col sui-h-full"
    >
      <DrawerHeader title="Add a Receipt" onClose={closeDrawer} />
      <DrawerBody style={{ height: isMobile ? '88vh' : '' }}>
        {drawerStepper === 0 ? (
          <Typography variant="body-base" weight="bold">
            How would you like to add a receipt?
          </Typography>
        ) : (
          <Typography variant="body-base" weight="bold">
            What kind of receipt would you like to add?
          </Typography>
        )}
        {drawerStepper === 1 && (
          <Typography variant="body-base">
            Receipts within 13 months of purchase may be added.
          </Typography>
        )}
        {drawerStepper === 1 && (
          <div className="sui-mt-[20px]">
            <RadioGroup
              aria-labelledby="dataType"
              name="dataType"
              onChange={handleFormChange}
              value={formType}
            >
              <SelectionControlLabel label="In-Store Receipt" value="InStore">
                <Radio />
              </SelectionControlLabel>
              <SelectionControlLabel label="Online Receipt" value="Online">
                <Radio />
              </SelectionControlLabel>
            </RadioGroup>
          </div>
        )}
      </DrawerBody>
      <DrawerFooter>
        <div className="ButtonGroup sui-min-w-full sui-flex sui-gap-4 sui-flex-col">
          <Button
            onClick={
              drawerStepper === 0
                ? () => handleContinueButton('Scan')
                : handleContinueButton
            }
            variant="primary"
          >
            {drawerStepper === 0 ? 'Scan Receipt' : 'Continue'}
          </Button>
          <Button
            onClick={
              drawerStepper === 0
                ? () => handleContinueButton('Select')
                : closeDrawer
            }
            variant="secondary"
          >
            {drawerStepper === 0 ? 'Manually Add Receipt' : 'Cancel'}
          </Button>
        </div>
      </DrawerFooter>
    </div>
  );
};
